export function formatUsd(value: number): string {
  const digits = value > 0 && value < 0.01 ? 6 : 4;
  return `$${value.toLocaleString("en-US", {
    maximumFractionDigits: digits,
    minimumFractionDigits: digits,
  })}`;
}

export function formatCostUsd(value: number): string {
  return value > 0 ? `≈ ${formatUsd(value)}` : "стоимость не сохранена";
}
